export enum TipoDesactivacion{
    PedidoDesactivacion,
    AprobacionDesactivacion
}